<template>
     <div class="bookings-options pt-2" :class="bookOptions" v-if="!showWaitCalendar">
        <div v-if="!openQr && userType == 1" class="close d-block d-sm-none" @click="closeOptions()"><i class="las la-times-circle"></i></div>
        <div class="m-0" v-show="openQr"> 
            <div class="d-flex justify-content-center align-items-center w-100 h-100">
                <div style="max-width: 450px">
                    <h5 class="text-center">Puedes mostrarle este QR al profesional el día de la cita para que acceda rápidamente a tu ficha</h5>
                    <div class="d-flex justify-content-center align-items-center w-100 qr-container mt-4 mb-4">
                        <img :src="qrUrl" class="img-fluid" style="max-width: 310px">
                    </div>
                    <button class="btn btn-outline-light" type="button" @click="openQr = false">Volver a las opciones</button> 
                </div>
            </div>
        </div>
        <div class="container-black" v-show="!openQr && booking.length > 0">
            <div v-for="b in booking" :key="b.id">
                <div class="row">
                    <div class=" col-3 col-md-2">
                        <div class=" img-container" v-if="userType != '1'">       
                            <img v-if="b.imgSeller != '@/assets/imgs/user-img-small.png'" :src="b.imgSeller" class="img-fluid img-user" /> 
                            <img v-else src="@/assets/imgs/user-img-small-gradient.png" class="img-fluid img-user" />
                        </div>
                        <div class=" img-container" v-if="userType == '1'">       
                            <img v-if="b.imgClient != '@/assets/imgs/user-img-small.png'" :src="b.imgClient" class="img-fluid img-user" />    
                            <img v-else src="@/assets/imgs/user-img-small-gradient.png" class="img-fluid img-user" />
                        </div>
                    </div>
                    <div class="col-9 col-md-10 details">
                        <div class="d-flex justify-content-start h-100 align-items-center">
                            <div>
                                <!--<small>REF: #{{ b.bookId }}</small>-->
                                <h5 class="m-0">Cita con:</h5>
                                <p class="m-0" v-if="userType != '1'">{{ b.sellerName }}</p>   
                                <p class="m-0" v-if="userType == '1'">{{ b.clientName }}</p>   
                            </div>
                        </div>
                    </div>
                </div>            
                <!-- balance pagar solo esta consulta-->
                <div class="container menu-options mt-3">
                    <div class="row">
                        <div class="col-12 mb-0 details"> 
                            <div v-if="!openQr && userType == 1" class="d-none d-sm-block close" @click="closeOptions()"><i class="las la-times" title="Cerrar opciones"></i></div>
                            <h5 class="therapy-name m-0 mt-2 mb-2"><img v-if="b.recurrent == '1'" title="Cita Recurrente" src="@/assets/imgs/recurrent.webp" class="recurrent-img d-block mx-auto" />{{ b.title }}</h5>
                            <small class="small m-0" v-if="b.groupId != ''">  
                                <span class="status-group-details">
                                    <p class="text-warning m-0"><i class="las la-users"></i> GRUPAL</p> 
                                </span>
                                <!--{{ b.title }}-->
                            </small>
                            <!--<small class="small m-0" v-else>{{ b.title }}</small>-->
                        </div>
                        <div class="pb-3 mt-0 d-grid gap-2 col-12 mx-auto">
                            <p class="price m-0"><i class="las la-stopwatch"></i> Duración {{ b.duration }}min.</p>
                            <div v-if="!b.now">
                                <span class="small fst-italic m-0">Día: <span v-if="b.now">hoy</span> <span v-if="!b.now"> {{ b.date }}</span> - Hora: <span v-if="userType == '1'">{{ b.hourStart }}</span><span v-else>{{ b.hourStartClient }}</span>.</span> 
                            </div>
                            <div v-if="b.now">
                                <span class="small fst-italic m-0">Día: <span v-if="b.now">hoy</span> <span v-if="!b.now"> {{ b.date }}</span> - Hora: <span v-if="userType == '1'">{{ b.hourStart }}</span> <span v-else>{{ b.hourStartClient }}</span>.</span>
                            </div>
                            <div v-if="b.modalityId != '1'">
                                <span class="small fst-italic m-0">Lugar: {{b.address}}</span>
                            </div>
                            <a v-if="userType == '1' && b.hidePrice == 0 && b.canCancel && b.canRemark && b.clientPhone != ''" class="pointer" style="font-size: 0.85rem;" @click="sendWa(b.id, 'room', b.groupId, b.clientName, b.linkVideoCall, b.roomIdLink, b.passVideoCall, b.now, b.date, b.hourStartClient, b.duration, b.service, b.clientPhone, b.modalityId, b.platformVideoCall, b.address)">Enviar recordatorio por WhatsApp</a>
                            <div v-if="b.price == 0 && userType == '1'" class="text-center">
                                
                                <div class="text-blue" v-if = "!addPriceMode && b.noPrice == 1 && userType == '1' && calendarEdit">
                                    <b>Enviar Link de Pago</b> <i class="las la-pencil-alt text-primary pointer" v-if="userType == '1' && b.pay == 0 && !addPriceMode && calendarEdit" @click="addPrice(b.price)"></i>
                                </div>
                                <div v-if = "addPriceMode && b.price == 0 && calendarEdit" class="p-1 bg-change-price mb-3">
                                    <div class="row"> 
                                        <div class="col-md-3" v-if="b.recurrent == '0'"></div>
                                        <div class="col-md-6" v-if="b.recurrent == '0'"> 
                                            <label>Valor de la consulta:</label> 
                                            <div class="d-flex align-items-center mb-3">
                                                <div class="m-2">
                                                    <p class="m-0"><b>{{b.currency}}</b></p>
                                                </div>
                                                <div class="input-group">
                                                    <input type="number" class="form-control form-control-lg text-center" attr-id="newPrice" v-model="newPrice"  @click="selectText()" autocomplete="new-newPrice"> 
                                                </div>
                                            </div>   
                                        </div>
                                        <div class="col-md-6" v-if="b.recurrent == '1'"> 
                                            <label>Valor de la consulta:</label> 
                                            <div class="d-flex align-items-center mb-3">
                                                <div class="m-2">
                                                    <p class="m-0"><b>{{b.currency}}</b></p>
                                                </div>
                                                <div class="input-group">
                                                    <input type="number" class="form-control form-control-lg text-center" attr-id="newPrice" v-model="newPrice" @click="selectText()" autocomplete="new-newPrice"> 
                                                </div>
                                            </div>   
                                        </div>
                                        <div class="col-md-6" v-if="b.recurrent == '1'"> 
                                            <label>Aplicar a:</label>  
                                            <select class="form-control form-control-lg" v-model="newPriceAllBookings">
                                                <option value="1">Únicamente esta cita</option>
                                                <option value="2">Esta cita y a las próximas</option>
                                            </select>
                                        </div>
                                        <div class="col-md-3" v-if="b.recurrent == '0'"></div>
                                        
                                        <div class="col-md-12 text-start mt-1 mb-3">
                                            <div class="form-check form-switch mx-auto">
                                                <input tabindex="16" class="form-check-input" type="checkbox" id="sendAdvicePrice" name="sendAdvicePrice" v-model="sendAdvicePrice">
                                                <label class="form-check-label" for="sendAdvicePrice">Enviar WhatsApp al consultante para realizar el pago.</label>
                                            </div>   
                                        </div>
                                        <div class="col-md-12 d-flex">           
                                            <button class="btn btn-secondary w-50 d-inline-block" @click="addPriceMode = false">Cancelar</button>
                                            <div class="m-2 d-inline-block"></div>
                                            <button @click="saveNewPrice(b.noPrice)" class="btn btn-primary w-50 d-inline-block" type="submit" :disabled="disabled"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span> Enviar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="b.price != 0" class="text-center"> 
                                <div class="text-blue" v-if = "!editPriceMode && b.hidePrice == 0">
                                    <b>{{b.currency}} {{b.price}}</b> <i class="las la-pencil-alt text-primary pointer" v-if="userType == '1' && b.pay == 0 && !editPriceMode && calendarEdit" @click="editPrice(b.price)"></i>
                                </div>
                                <div v-if = "editPriceMode && b.price != 0 && calendarEdit" class="p-1 bg-change-price mb-3">
                                    <div class="row"> 
                                        <div class="col-md-3" v-if="b.recurrent == '0'"></div>
                                        <div class="col-md-6" v-if="b.recurrent == '0'"> 
                                            <label>Nuevo Precio:</label> 
                                            <div class="d-flex align-items-center mb-3">
                                                <div class="m-2">
                                                    <p class="m-0"><b>{{b.currency}}</b></p>
                                                </div>
                                                <div class="input-group">
                                                    <input type="number" class="form-control form-control-lg text-center" attr-id="newPrice" v-model="newPrice"  @click="selectText()" autocomplete="new-newPrice"> 
                                                </div>
                                            </div>   
                                        </div>
                                        <div class="col-md-6" v-if="b.recurrent == '1'"> 
                                            <label>Nuevo Precio:</label> 
                                            <div class="d-flex align-items-center mb-3">
                                                <div class="m-2">
                                                    <p class="m-0"><b>{{b.currency}}</b></p>
                                                </div>
                                                <div class="input-group">
                                                    <input type="number" class="form-control form-control-lg text-center" attr-id="newPrice" v-model="newPrice" @click="selectText()" autocomplete="new-newPrice"> 
                                                </div>
                                            </div>   
                                        </div>
                                        <div class="col-md-6" v-if="b.recurrent == '1'"> 
                                            <label>Aplicar a:</label>  
                                            <select class="form-control form-control-lg" v-model="newPriceAllBookings">
                                                <option value="1">Únicamente esta cita</option>
                                                <option value="2">Esta cita y a las próximas</option>
                                            </select>
                                        </div>
                                        <div class="col-md-3" v-if="b.recurrent == '0'"></div>
                                        <div class="col-md-3" v-if="b.recurrent == '0'"></div>
                                        <div class="col-md-6 text-start mt-2 mb-2" v-if="b.recurrent == '0'">
                                            <div class="form-check form-switch">
                                                <input tabindex="16" class="form-check-input" type="checkbox" id="sendAdvicePrice" name="sendAdvicePrice" v-model="sendAdvicePrice">
                                                <label class="form-check-label" for="sendAdvicePrice">Dar aviso al consultante del cambio de precio.</label>
                                            </div>   
                                        </div>
                                        <div class="col-md-12 text-start mt-2 mb-2" v-if="b.recurrent == '1'">
                                            <div class="form-check form-switch">
                                                <input tabindex="16" class="form-check-input" type="checkbox" id="sendAdvicePrice" name="sendAdvicePrice" v-model="sendAdvicePrice">
                                                <label class="form-check-label" for="sendAdvicePrice">Dar aviso al consultante del cambio de precio.</label>
                                            </div>   
                                        </div>
                                        <div class="col-md-12 d-flex">           
                                            <button class="btn btn-secondary w-50 d-inline-block" @click="editPriceMode = false">Cancelar</button>
                                            <div class="m-2 d-inline-block"></div>
                                            <button @click="saveNewPrice(b.noPrice)" class="btn btn-primary w-50 d-inline-block" type="submit" :disabled="disabled"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span> Aplicar</button>
                                        </div>
                                    </div>
                                </div>
                            
                            </div>
                            <div>
                                <span class="badge text-uppercase" :class="b.modalityClass">
                                    {{b.modality}}
                                </span> 
                                <span class="badge bg-success" v-if="b.pay == 0 && b.price == 0 && b.hidePrice == 0 && b.noPrice == 0">
                                    GRATIS
                                </span> 
                                <span class="badge bg-danger" v-if="b.pay == 0 && b.price != 0 && b.hidePrice == 0 && b.noPrice == 0">
                                    IMPAGA
                                </span> 
                                <span class="badge bg-success" v-if="b.pay == 1 && b.price != 0 && b.hidePrice == 0 && b.noPrice == 0">
                                    ABONADA
                                </span> 
                            </div>
                            <small v-if="idQtySessions != '' && booknextTurnListings.length > 0 && b.pay == 0 && b.price != 0 && b.hidePrice == 0 && userType != '1'" class="text-blue"><b>Una vez realizado el pago, podrás seleccionar las próximas fechas.</b> Consultá en tu WhatsApp los datos bancarios para hacer la transferencia y recordá enviar el comprobante por ese mismo medio.</small>
                            <div v-show="b.platformVideoCall != 'Animasana' && b.platformVideoCall != 'Meet' && b.platformVideoCall != 'Zoom' && b.platformVideoCall != 'WhatsApp' && b.hidePrice == 0">
                                <p v-if="b.platformVideoCall == 'Otra'"> Link a la sala de videoconferencia externa: <br> <a :href="b.linkVideoCall" target="blank">{{b.linkVideoCall}}</a></p>
                                <p v-else> Link a la sala de videoconferencia de {{b.platformVideoCall}}: <br> <a :href="b.linkVideoCall" target="blank">{{b.linkVideoCall}}</a></p>
                                <p v-if="b.passVideoCall != ''">Contraseña para ingresar a la sala: <b>{{b.passVideoCall}}</b></p>
                                <p v-if="b.roomIdLink != ''">Id de reunión: <b>{{b.roomIdLink}}</b></p>    
                            </div>
                            <div v-if="b.platformVideoCall == 'WhatsApp' && b.hidePrice == 0 && userType != '1'">
                                <p v-if="b.clientPhone != ''" class="text-center small fst-italic alert alert-info mt-2">{{ b.sellerName }} te hará una video llamada por WhatsApp al +{{ b.clientPhone}} cuando sea el día y hora de la cita.</p>
                                <p v-else class="text-center small fst-italic alert alert-info mt-2">Necesitamos que agregues un numero de WhatsApp para que {{ b.sellerName }} pueda hacer la video llamada cuando sea el día de la cita.<br>
                                    <router-link class="pointer link" :to="{name: 'change-user-phone'}">
                                        Agregar Teléfono
                                    </router-link>  
                                </p>
                            </div>
                            <h3 class="fs-5 fw-500 text-blue text-center" v-if="userType != '1' && b.hidePrice == 0">Opciones de la cita</h3>
                            <h3 class="fs-5 fw-500 text-blue text-center" v-if="userType == '1' && b.hidePrice == 0 && (calendarEdit || calendarCancel || contactsView)">Opciones de la cita</h3>
                            <div class="pb-3 mt-0 d-grid gap-2 col-12 mx-auto" v-if="userType != '1' && b.hidePrice == 0">
                                <button v-if="b.modalityId != '1' && b.canCancel" class="btn btn-primary" type="button" @click="showQr(b.id)"><i class="las la-qrcode"></i> Ver QR de la cita</button>  
                                <button v-if="idQtySessions != '' && booknextTurnListings.length > 0 && b.pay == 1 && b.price != 0 && b.hidePrice == 0" class="btn btn-primary" type="button"  @click=" this.$router.push({ name: 'next-session', params: {ref : b.id}});">Agendar proximas fechas</button>
                                <button v-if="idQtySessions != '' && booknextTurnListings.length > 0 && b.pay == 0 && b.price == 0 && b.hidePrice == 0" class="btn btn-primary" type="button"  @click=" this.$router.push({ name: 'next-session', params: {ref : b.id}});">Agendar proximas fechas</button>
                                <button v-if="b.createByProf == 0 && booknextTurnListings.length == 0" class="btn btn-primary" type="button" @click="openBuyAgain(b.linkId)"><i class="las la-redo-alt"></i> Volver a contratar</button>  
                                <button v-if="b.now && b.modalityId == '1' && b.canCalificate && b.platformVideoCall == 'Animasana'" class="btn btn-primary" type="button"  @click="goAction(b.id, 'room', b.groupId, b.address)">Ingresar a la sala</button>
                                <button v-if="!b.now && b.modalityId == '1' && !b.canCalificate && b.platformVideoCall == 'Animasana'" disabled class="btn btn-primary" type="button">Ingresar a la sala</button>
                                <button v-if="b.now && b.modalityId == '1' && b.canCalificate && b.platformVideoCall == 'Meet'" @click="goToMeet(b.linkVideoCall)" class="btn btn-primary" type="button">Ingresar a Google Meet</button>
                                <button v-if="!b.now && b.modalityId == '1' && !b.canCalificate && b.platformVideoCall == 'Meet'" disabled class="btn btn-primary" type="button">Ingresar a Google Meet</button>
                                <button v-if="b.now && b.modalityId == '1' && b.canCalificate && b.platformVideoCall == 'Zoom'" @click="goToMeet(b.linkVideoCall)" class="btn btn-primary" type="button">Ingresar a Zoom</button>
                                <button v-if="!b.now && b.modalityId == '1' && !b.canCalificate && b.platformVideoCall == 'Zoom'" disabled class="btn btn-primary" type="button">Ingresar a Zoom</button>
                                <button v-if="b.canCancel && b.canRemark && b.createByProf == 0" class="btn btn-secondary" type="button" @click="goAction(b.id, 'remark')">Reprogramar fecha</button>
                                <button v-if="!b.canCancel && !b.canRemark && b.createByProf == 0" class="btn btn-secondary" type="button" disabled title="Solo puedes reprogramar una fecha antes de la fecha y hora reservada.">Reprogramar fecha</button>
                                <!--<button v-if="b.canCalificate" class="btn btn-secondary" type="button" @click="goAction(b.id, 'calificate')"><div v-if="!b.isCalificatedClient">Calificar al profesional</div><div v-if="b.isCalificatedClient">Ver calificación</div></button>  
                                <button v-if="!b.canCalificate" class="btn btn-secondary" disabled title="Una vez pasada la fecha de la consulta podrás calificar.">Calificar al profesional</button>-->
                                <!--<button v-if="b.pay == 0 && b.hasContact && b.canCancel" class="btn btn-secondary" type="button" @click="goAction(b.idContact, 'bot')">Enviar comprobante de pago</button> 
                                <button v-if="b.pay == 1 && b.hasContact && b.canCancel" class="btn btn-secondary" type="button" disabled>Enviar comprobante de pago</button>  
                                <button v-if="b.pay == 0 && b.hasContact && !b.canCancel" class="btn btn-secondary" type="button" disabled>Enviar comprobante de pago</button>-->  
                                <button v-if="b.canCancel" class="btn btn-danger" type="button" @click="goAction(b.id, 'cancelation')">Cancelar cita</button>
                                <button v-if="!b.canCancel" class="btn btn-danger" type="button" disabled title="Solo puedes cancelar una cita antes de la fecha y hora reservada.">Cancelar cita</button>
                            </div>
                            <div class="pb-3 mt-0 d-grid gap-2 col-12 mx-auto" v-if="userType == '1' && b.hidePrice == 0">  
                                <button v-if="b.groupId != ''" class="btn btn-outline-light" type="button" @click="showMembersGroup(b.groupId)">Participantes</button>            
                                <!-- <button v-if="b.now && !b.canCalificate && b.canCancel" class="btn btn-outline-light btn-lg" type="button"  @click="markReady(b.id)">Marcar como realizada</button>-->  
                                <button v-if="b.now && b.modalityId == '1' && b.canCalificate && b.platformVideoCall == 'Animasana'" class="btn btn-primary" type="button"  @click="goAction(b.id, 'room', b.groupId, b.address)">Ingresar a la sala</button>
                                <button v-if="!b.now && b.modalityId == '1' && !b.canCalificate && b.platformVideoCall == 'Animasana'" disabled class="btn btn-primary" type="button">Ingresar a la sala</button>
                                <button v-if="b.now && b.modalityId == '1' && b.canCalificate && b.platformVideoCall == 'Meet'" @click="goToMeet(b.linkVideoCall)" class="btn btn-primary" type="button">Ingresar a Google Meet</button>
                                <button v-if="!b.now && b.modalityId == '1' && !b.canCalificate && b.platformVideoCall == 'Meet'" disabled class="btn btn-primary" type="button">Ingresar a Google Meet</button>
                                <button v-if="b.now && b.modalityId == '1' && b.canCalificate && b.platformVideoCall == 'Zoom'" @click="goToMeet(b.linkVideoCall)" class="btn btn-primary" type="button">Ingresar a Zoom</button>
                                <button v-if="!b.now && b.modalityId == '1' && !b.canCalificate && b.platformVideoCall == 'Zoom'" disabled class="btn btn-primary" type="button">Ingresar a Zoom</button>
                                <button v-if="b.now && b.modalityId == '1' && b.canCalificate && b.platformVideoCall == 'WhatsApp'" @click="goToWhatsApp(b.clientPhone)" class="btn btn-primary" type="button">Video llamada por WhatsApp</button>
                                <button v-if="!b.now && b.modalityId == '1' && !b.canCalificate && b.platformVideoCall == 'WhatsApp'" disabled class="btn btn-primary" type="button">Video llamada por WhatsApp</button>
                                <button class="btn btn-secondary" type="button" @click="goAction(b.id, 'remark')" v-if="calendarEdit">Reprogramar fecha</button>
                                <button v-if="adminUserType == 3" class="btn btn-secondary" type="button" @click="callTurn(b.clientName)" :disabled="disabled"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span> Anunciar</button>
                                <button v-if="b.canCancel && b.canRemark && b.pay == 0 && b.price != 0 && b.hidePrice == 0 && b.modalityId != '1' && calendarEdit" class="btn btn-secondary" type="button" @click="markPay(b.id)">Marcar cita como pagada</button>
                                <!--<button v-if="b.isCalificatedClient" class="btn btn-secondary" type="button" @click="goAction(b.id, 'calificate')">Ver Calificación</button>
                                <button v-if="!b.isCalificatedClient" class="btn btn-secondary" type="button" disabled title="Una vez pasada la fecha de la consulta podrá calificar el usuario.">Aun no te Califico</button>-->
                                <!--<button v-if="b.hasContact" class="btn btn-outline-light" type="button" @click="goAction(b.idContact, 'chat')">Chat</button>-->
                                <button v-if="b.hasContact && !hideBtnClient && contactsView" class="btn btn-secondary" type="button" @click="goAction(b.idContact, 'record')">Ver ficha</button>
                                <button class="btn btn-danger" type="button" @click="goAction(b.id, 'cancelation')" v-if="calendarCancel">Cancelar cita</button>
                               
                                <button v-if="b.recurrent == 1 && calendarCancel" class="btn btn-danger" type="button"  @click="deleteRecurrent(b.id, b.dateNoFormat, b.date, b.hourStart)">Eliminar cita recurrente</button>
                                
                            </div>
                            <div class="pb-3 mt-0 d-grid gap-2 col-12 mx-auto" v-if="userType == '1' && b.hidePrice == 1 && b.priceProfOk == 0"> 
                                <div class="row">
                                    <div class="col-md-3"></div>
                                    <div class="col-md-6"> 
                                        <h6 class="mt-3 text-green">Confirmar precio de la cita:</h6> 
                                        <div class="d-flex align-items-center mb-3">
                                            <div class="m-2">
                                                <p class="m-0"><b>{{b.currency}}</b></p>
                                            </div>
                                            <div class="input-group">
                                                <input type="number" class="form-control form-control-lg text-center" attr-id="manualPrice" v-model="manualPrice" @click="selectText2()" autocomplete="new-manualPrice"> 
                                            </div>
                                        </div>  
                                    </div>
                                    <div class="col-md-3"></div>
                                    <div class="col-md-2"></div>
                                    <div class="col-md-8 text-start"> 
                                        <hr>
                                        <balances-prof v-if="b.userCountry != ''" :userSelected="b.customerId" userMode="1" showAll="false" textButton="Ingresar Pago" :hideDetails="true" :modality="b.modalityId" :cosnCountry="b.userCountry"></balances-prof> 
                                    </div>
                                    <div class="col-md-2"></div>
                                    <div class="col-md-12 mt-3">  
                                        <div class="d-flex">         
                                            <button class="btn btn-secondary me-2 w-50 d-inline-block gap-1" @click="closeOptions()">Cancelar</button>
                                            <button @click="confirmPrice()" class="btn btn-primary w-50 d-inline-block" type="submit" :disabled="disabled"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span> Confirmar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="pb-3 mt-0 d-grid gap-2 col-12 mx-auto" v-if="userType == '2' && b.hidePrice == 1 && b.priceProfOk == 1"> 
                                <div class="row">
                                    <div class="col-md-3"></div>
                                    <div class="col-md-6"> 
                                        <h5 class="mt-3 text-green">Confirma el valor de la cita:</h5> 
                                        <h4 class="mt-3"><b>{{b.currency}} {{manualPrice}}</b></h4>
                                        <p class="fst-italic lh-sm fw-light">Si estas de acuerdo con el valor te pedimos que confirmes para dejar agendada la cita. Tienes 24hs para hacerlo de lo contrario se anulará.</p>   
                                    </div>
                                    <div class="col-md-3"></div>
                                    <div class="col-md-12 mt-3">
                                        <div class="d-flex">           
                                            <button class="btn btn-secondary gap-2 w-50 me-2" @click="confirmUserPrice(false, b.id)" :disabled="disabled"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span> Rechazar</button>
                                            <button @click="confirmUserPrice(true, b.id)" class="btn btn-primary w-50" :disabled="disabled"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span> Confirmar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="pb-3 mt-0 d-grid gap-2 col-12 mx-auto" v-if="userType != '1' && b.hidePrice == 1 && b.priceProfOk == 0"> 
                                <div class="row">  
                                    <div class="col-md-12">
                                        <h5 class="mt-3 text-green"><i class="las la-hourglass-half"></i> Esperando a que el Profesional confirme la cita.</h5>
                                        <p class="fst-italic lh-sm fw-light">Recibirás un aviso por email o SMS dentro de las próximas horas.</p>
                                    </div> 
                                </div>
                                <button class="btn btn-outline-primary mt-3" @click="closeOptions()">Salir</button> 
                            </div>
                            <div class="pb-3 mt-0 d-grid gap-2 col-12 mx-auto" v-if="userType == '1' && b.hidePrice == 1 && b.priceProfOk == 1"> 
                                <div class="row">  
                                    <div class="col-md-12">
                                        <h5 class="mt-3 text-green">Le notificamos al consultante.</h5>
                                        <h6 class="mt-3 fw-light"><i class="las la-hourglass-end text-green"></i> Esperando a que confirme el precio de la cita.</h6>
                                    </div> 
                                </div>
                                <button class="btn btn-outline-primary mt-3" @click="closeOptions()">Salir</button> 
                            </div>
                            <div class="cnt-list-group" v-if="usersGroup.length > 0">
                                <h5 class="text-center mb-2"><i class="las la-users"></i> Participantes</h5>
                                <div class="card mb-3" v-for="b in usersGroup" :key="b.clientId">
                                    <div class="row g-1">
                                        <div class="col-2 col-md-2">
                                            <div class="d-flex align-items-center h-100 p-1">
                                                <img v-if="b.imgClient != '@/assets/imgs/user-img-small.png'" :src="b.imgClient" class="img-fluid user-img rounded-circle" />    
                                                <img v-else src="@/assets/imgs/user-img-small-gradient.png" class="img-fluid  user-img" />
                                            </div>
                                        </div>
                                        <div class="col-7 col-md-6">
                                            <div class="d-flex align-items-center h-100">
                                                <p class="m-0">{{b.clientName}}</p>
                                            </div>
                                        </div>
                                        <div class="d-none d-sm-block col-md-2">
                                            <div class="d-flex align-items-center h-100">
                                                <button class="btn btn-outline-primary btn-sm" @click="findOtherBooking(b.id)">Ver cita</button>
                                            </div>
                                        </div>
                                        <div class="col-3 col-md-2">    
                                            <div class="d-flex align-items-center h-100">
                                                <span class="badge bg-success" v-if="b.pay == 0 && b.price == 0 && b.hidePrice == 0">
                                                    GRATIS
                                                </span> 
                                                <span class="badge bg-danger" v-if="b.pay == 0 && b.price != 0 && b.hidePrice == 0">
                                                    IMPAGA
                                                </span> 
                                                <span class="badge bg-success" v-if="b.pay == 1 && b.price != 0 && b.hidePrice == 0">
                                                    ABONADA
                                                </span> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--<button v-if="b.hidePrice == 0" class="btn btn-outline-primary mt-3" @click="closeOptions()">Cerrar opciones de la cita</button>--> 
                            <small class="text-muted text-center mt-3">ID de contratación: #{{ b.bookId }}</small>        
                        </div>
                    </div>
                </div>     
            </div>
        </div>
        <div class="container-black mt-5" v-if="booking.length == 0 && !hideNotFound">
            <div>
                <img src="@/assets/imgs/sad.webp" class="img-fluid"  style="max-width: 100px" />
                <h4 class="mt-3">No encontramos la cita</h4>
            </div>
        </div>
        <div class="container-black mt-5" v-show="booking.length == 0 && hideNotFound">
            <div>
                <img src="@/assets/imgs/spinner-white.webp" class="img-fluid"  style="max-width: 100px" />
                <h4 class="mt-3">Actualizando info</h4>
            </div>
        </div>
        
    </div>

    <div style="z-index: 200000; position: fixed;">
        <buy-again v-if="buyAgainTurns" :publishId="buyAgainId"></buy-again>
    </div>
    <div class="mx-auto position-fixed bottom-0 end-0 start-0 end-0 p-0 pt-3 pb-3" style="z-index: 200000; width: fit-content; margin-bottom: 0px;">
        <div id="toastcontainer3" class="w-25">
        </div>
    </div>
    <div class="d-flex justify-content-center align-items-center h-100 w-100 screen-waiting-calendar" v-if="this.showWaitCalendar == true">
        <div>
            <img src="@/assets/imgs/spinner-white.webp" class="img-fluid w-25">
            <h3>Eliminando los turnos recurrentes para esta cita...</h3>
            <h4>Esta operación puede demorar un tiempo.</h4>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import balancesPayPublish from '@/components/dashboard/balances-pay-publish.vue'
import balancesProf from '@/components/dashboard/balances-prof.vue'
import buyAgain from '@/components/publications/buy-again.vue'
import { Toast } from 'bootstrap'
export default {   
    name: "booking-menu",
    props: ['userId', 'bookingId', 'userType', 'localZone'],
    components: {   
        balancesPayPublish,
        balancesProf,
        buyAgain
    },
    data(){
        return{
            errorText: '',
            toastColor: '',
            toastBg: '',
            toastNumber: 0,
            dataReceiver: '',
            booking: [],
            booknextTurnListings: [],
            idQtySessions: '',
            openQr: false,
            qrUrl: '',
            bookOptions: '',

            activeCard: '',
            buyAgainTurns: false,
            buyAgainId: '',
            usersGroup: [],
            showWaitCalendar: false,
            hideBtnClient: true,
            editPriceMode: '',
            addPriceMode: '',
            oldPrice: '',
            newPrice: '',
            newPriceAllBookings: 1,
            sendAdvicePrice: true,
            loading: false,
            disabled: false,
            hideNotFound: false,
            manualPrice: 0,
            userCountryBank: '',
            userFirstNameBank: '',
            userLastNameBank: '',
            userTypeBank: '',
            userBankName: '',
            userCurrencyBank: '',
            userCbuBank: '',
            userAliasBank: '',
            payCashTurns: false,
            payCardTurns: false,
            cbuText: '',
            adminUserType: 0
        }
    },
    mounted: function () {    
        console.log('openBooking')  //importante para la app 
        if(this.$route.name != 'clients'){
            this.hideBtnClient = false;
        }else{
            this.hideBtnClient = true;
        } 
        this.findAdministrators('all', '');       
        this.findBookings();
    },
    computed: {
        calendarEdit() {
            var show = true;
            if (localStorage.getItem("corporativeIn") !== null && localStorage.getItem("corporativeIn") !== "") {
                show = this.$root.corporatePermissions('calendarEdit');
            }
            return show
        },
        calendarCancel() {
            var show = true;
            if (localStorage.getItem("corporativeIn") !== null && localStorage.getItem("corporativeIn") !== "") {
                show = this.$root.corporatePermissions('calendarCancel');
            }
            return show
        },
        contactsView() {
            var show = true;
            if (localStorage.getItem("corporativeIn") !== null && localStorage.getItem("corporativeIn") !== "") {
                show = this.$root.corporatePermissions('contactsView');
            }
            return show
        },
    },
    methods:{
        async findAdministrators(find, id){ 
            var payload = {
                action: 'find-corpo-administrators',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.userId,
                find: find,
                adminId: id
            }
            await axios.post('/index.php', payload).then(result => {      
                if(result.data.length > 0){
                    // Recorremos admins
                    this.admins = result.data;
                    this.admins.forEach(admin => {
                        if (
                            admin.status === 1 &&
                            admin.userType === "3" &&
                            admin.userId === localStorage.getItem('token')
                        ) {
                            this.adminUserType = 3;
                        }
                    }); 
                } 
                this.findturns();
            })
            .catch(error => {
                return;
            })  
        },
        async callTurn(val){
            this.loading = true;
            this.disabled = true;  
            var payload = {
                action: 'call-turnbox',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.userId, 
                name: val,
                box: localStorage.getItem('doctorBox')
            }
            await axios.post('/index.php', payload).then(result => {
                this.loading = false;
                this.disabled = false; 
                if(result.data.status == '200'){    
                    this.errorText = 'Paciente anunciado.';
                    this.toastBg = 'bg-success';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer3').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }     
                }else if(result.data.status == '400'){  
                    this.errorText = 'No fue posible anunciar al paciente.';
                    this.toastBg = 'bg-danger';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer3').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){
                       
                    }
                    return;
                }
              
            })
            .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer3').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }   
                return;
            }) 
        },
        editPrice(val){
            this.oldPrice = val;
            this.newPrice = val;
            this.newPriceAllBookings = 1;
            this.sendAdvicePrice = true;
            this.editPriceMode = true;
            
        },
        addPrice(val){
            this.oldPrice = val;
            this.newPrice = val;
            this.newPriceAllBookings = 1;
            this.sendAdvicePrice = true;
            this.addPriceMode = true;
            
        },
        selectText(){         
            document.querySelector("[attr-id='newPrice']").select();    
        },
        selectText2(){         
            document.querySelector("[attr-id='manualPrice']").select();    
        },
        async saveNewPrice(val){
            this.loading = true;
            this.disabled = true;  
            var payload = {
                action: 'update-booking-price',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.userId, 
                ref: this.bookingId,
                oldPrice: this.oldPrice,
                newPrice: this.newPrice,
                sendAdvice: this.sendAdvicePrice,
                allbooking: this.newPriceAllBookings,
                noPrice: val
            }
            await axios.post('/index.php', payload).then(result => {
                this.loading = false;
                this.disabled = false;  
                try{
                    document.querySelector("[attr-id='newPrice']").classList.remove("bad");   
                }catch(e){

                }
                if(result.data.status == '200'){    
                    try{
                        this.$parent.findturns();
                    }catch(e){

                    }
                    this.errorText = 'Importe Actualizado';
                    this.toastBg = 'bg-success';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer3').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                        this.hideNotFound = true;
                        this.findBookings();
                        this.editPriceMode = false;
                        this.addPriceMode = false;
                    }catch(e){

                    }     
                }else if(result.data.status == '400'){
                    if(result.data.error == 'E20'){
                        this.errorText = 'Debes ingresar el nuevo importe.';
                        try{
                            document.querySelector("[attr-id='newPrice']").classList.add("bad"); 
                            document.querySelector("[attr-id='newPrice']").select();
                        }catch(e){

                        }
                    }else if(result.data.error == 'E21'){
                        this.errorText = 'El importe ingresado no es correcto.';
                        try{
                            document.querySelector("[attr-id='newPrice']").classList.add("bad"); 
                            document.querySelector("[attr-id='newPrice']").select();
                        }catch(e){

                        }
                    }else if(result.data.error == 'E22'){
                        this.errorText = 'El importe ingresado no es correcto.';
                        try{
                            document.querySelector("[attr-id='newPrice']").classList.add("bad"); 
                            document.querySelector("[attr-id='newPrice']").select();
                        }catch(e){

                        }
                    }
                    this.toastBg = 'bg-danger';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer3').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){
                       
                    }
                    return;
                }
              
            })
            .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer3').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }   
                return;
            }) 
        },

        async markReady(val){
            var answer = confirm('¿Deseas marcar como realizada la consulta?');
	        if (answer){
                var payload = {
                    action: 'mark-ready',
                    browserCountry: this.$route.params.browserCountry,
                    userLang: this.$route.params.userLang,
                    urlcode: window.location.host,
                    dataReceiver: this.userId, 
                    timezone: this.localZone,
                    ref: val
                }
                await axios.post('/index.php', payload).then(result => {
                    this.$parent.reloadbooking();
                    this.closeOptions();
                })
                .catch(error => {
                    this.errorText = 'Revise su conexión de internet.';
                    this.toastBg = 'bg-danger';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer3').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }   
                    return;
                }) 
            }
        },
        async findBookings(){  
            this.booking = [];
            this.activeCard = '';
            var payload = {
                action: 'find-bookings',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.userId, 
                mode: this.userType,
                next: 0,
                filter: 1,
                date: 'one',
                timezone: this.localZone,
                ref: this.bookingId
            }
            await axios.post('/index.php', payload).then(result => {
                this.hideNotFound = false;
                if(result.data.length > 0){   
                    let sum = 0;
                    Object.keys(result.data).forEach(key => {
                        this.booking.push(result.data[sum]); 
                        this.manualPrice = result.data[sum].price;
                        this.idQtySessions = result.data[sum].idQtySessions;
                        if(this.idQtySessions != '' && this.userType == '2'){
                            this.findNextSesions();
                        }
                        sum++;                        
                    });
                    this.bookOptions = 'on'; 
                    
                }else{
                    this.bookOptions = 'on';
                }   
            })
            .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer3').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }   
                return;
            })
        },
        async findNextSesions(){ 
            var payload = {
                action: 'find-next-sessions',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.userId, 
                ref: this.idQtySessions,
                timezone: this.localZone
            }
            await axios.post('/index.php', payload).then(result => {
                this.booknextTurnListings = result.data;        
            })
            .catch(error => {   
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }   
                return;
            })
        },

        closeOptions(){
            console.log('closeBooking')  //importante para la app
            this.$parent.closeOptions();
        },
        openBuyAgain(val){
            this.buyAgainId = val;
            this.buyAgainTurns = true;
        },
        closeBuyAgain(){
            this.buyAgainTurns = false;
        },
        async showQr(val){
            this.openQr = false;
            this.qrUrl = '';
            var payload = {
                action: 'generete-booking-qr',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                ref: val    
            } 
            await axios.post('/index.php', payload)
            .then(result => {   
                if(result.data.status == '200'){
                    if(window.location.host == 'h.animasana.net' || window.location.host == 'animasana.net'){
                        this.qrUrl = 'https://api.animasana.net/' + result.data.file;  
                    }else if(window.location.host == 'api-qa.animasana.net'){   
                        this.qrUrl = 'https://api-qa.animasana.net/' + result.data.file;  
                    }else{        
                        this.qrUrl = 'https://api-qa.animasana.net/' + result.data.file;      
                    }
                    this.openQr = true;
                }      
            });
        },

        goAction(id, action, group){
            if(action == 'calificate'){
                if(this.userType == '1'){
                    this.$router.push({ name: 'seller-calification', params: { ref: id }});
                }else{
                    this.$router.push({ name: 'client-calification', params: { ref: id }});
                }
            }else if(action == 'cancelation'){
                if(this.userType == '1'){
                    this.$router.push({ name: 'seller-cancelation', params: { ref: id }});
                }else{
                    this.$router.push({ name: 'client-cancelation', params: { ref: id }});
                }
            }else if(action == 'remark'){
                if(this.userType == '1'){
                    this.$router.push({ name: 'seller-remark', params: { ref: id }});
                }else{
                    this.$router.push({ name: 'client-remark', params: { ref: id }});
                }    
            }else if(action == 'chat'){
                if(this.userType == '1'){
                    this.$router.push({ name: 'prof-chat', params: { ref: id }});
                }else{
                    this.$router.push({ name: 'chat', params: { ref: id }});
                }
            }else if(action == 'bot'){
                if(window.location.host == 'h.animasana.net' || window.location.host == 'animasana.net'){
                    this.whatsAppClient = '541169645225';
                }else if(window.location.host == 'qa.front-ews.pages.dev'){
                    this.whatsAppClient = '541135109050';
                }else{
                    this.whatsAppClient = '541135109050';
                }

                location.href = 'https://api.whatsapp.com/send?phone=' + this.whatsAppClient + '&text=Quisiera%20informar%20un%20pago.'
            }else if(action == 'room'){
                this.$router.push({ name: 'room', params: { ref: id, group: group }});
            }else if(action == 'record'){
                this.$router.push({ name: 'clients', params: { ref: id }});
            }
            document.querySelector('html').style.overflow = 'auto';
        },
        async markPay(val){
            var answer = confirm('¿Confirmas que has cobrado la cita en efectivo?');
	        if (answer){   
                var payload = {
                    action: 'mark-pay-booking',
                    browserCountry: this.$route.params.browserCountry,
                    userLang: this.$route.params.userLang,
                    urlcode: window.location.host,
                    ref: val
                }
                this.hideNotFound = true;
                await axios.post('/index.php', payload).then(result => {
                    this.errorText = 'La cita cambio al estado de abonada.';
                    this.toastBg = 'bg-info';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                   
                    try{
                        document.querySelector('#toastcontainer3').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it    
                        this.findBookings()
                    }catch(e){

                    }		
                    this.$parent.reloadbooking();
                })
                .catch(error => {
                    this.errorText = 'Revise su conexión de internet.';
                    this.toastBg = 'bg-danger';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer3').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }   
                    return;
                })
            }
        },
        async deleteRecurrent(val, fromDate, date, hour){
            var answer = confirm('ATENCIÓN: Solo se eliminaran todas las citas futuras incluyendo la del '+ date + ' a las ' + hour + '. ¿Deseas eliminar la cita recurrente?');
	        if (answer){   
                var payload = {
                    action: 'delete-recurrent',
                    browserCountry: this.$route.params.browserCountry,
                    userLang: this.$route.params.userLang,
                    urlcode: window.location.host,
                    dataReceiver: this.userId, 
                    timezone: this.localZone,
                    fromDate: fromDate,
                    ref: val
                }
                this.showWaitCalendar = true;
                await axios.post('/index.php', payload).then(result => {
                    if(result.data.status == '400'){
                        if(result.data.error == 'E20'){
                            this.errorText = 'No es posible eliminar citas recurrentes desde una fecha inferior a la actual';
                            this.toastBg = 'bg-info';
                            this.toastColor = 'text-dark';
                            this.toastNumber++;
                            var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                        
                            try{
                                document.querySelector('#toastcontainer3').insertAdjacentHTML("afterend", t);
                                var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                                var bsAlert = new Toast(myAlert);//inizialize it
                                bsAlert.show();//show it    
                            }catch(e){

                            }		    
                        }
                        this.showWaitCalendar = false;
                    }else{
                        this.errorText = 'Las citas recurrentes fueron eliminadas.';
                        this.toastBg = 'bg-info';
                        this.toastColor = 'text-dark';
                        this.toastNumber++;
                        var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    
                        try{
                            document.querySelector('#toastcontainer3').insertAdjacentHTML("afterend", t);
                            var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                            var bsAlert = new Toast(myAlert);//inizialize it
                            bsAlert.show();//show it    
                        }catch(e){

                        }		
                        this.showWaitCalendar = false;
                        this.$parent.reloadbooking();
                        this.closeOptions(); 
                    }            
                })
                .catch(error => {
                    this.errorText = 'Revise su conexión de internet.';
                    this.toastBg = 'bg-danger';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer3').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }   
                    return;
                })
            }
        },
        async showMembersGroup(val){
            this.usersGroup =[];
            var payload = {
                action: 'find-group-room-data',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.userId,
                ref: val
            }
            await axios.post('/index.php', payload).then(result => { 
                this.usersGroup = result.data; 
            })
            .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer3').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }   
                return;
            })       

        }, 
        findOtherBooking(val){
            this.$parent.findOtherBooking(val);
        },
        sendTypePayments(payCashTurns, payCardTurns){
            this.payCashTurns = payCashTurns;
            this.payCardTurns = payCardTurns;  
        },

        sendDataChange(userCountryBank, userFirstName, userLastName, userTypeBank, userBankName, userCurrencyBank, userCbuBank, userAliasBank, cbuText){
            this.userCountryBank = userCountryBank;
            this.userFirstNameBank = userFirstName;
            this.userLastNameBank = userLastName;
            this.userTypeBank = userTypeBank;
            this.userBankName = userBankName;
            this.userCurrencyBank = userCurrencyBank;
            this.userCbuBank = userCbuBank;
            this.userAliasBank = userAliasBank;
            this.cbuText = cbuText;
        },

        async confirmPrice(){
            var elems = document.querySelectorAll(".bad");
            [].forEach.call(elems, function(el) {
                el.classList.remove("bad");
            });
            this.errorText = '';
            this.loading = true;
            this.disabled = true;  
            var payload = {
                action: 'confirm-booking-price',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.userId, 
                ref: this.bookingId,
                newPrice: this.manualPrice,
                payCash: this.payCashTurns,
                payCard: this.payCardTurns,
                userFirstName: this.userFirstNameBank,
                userLastName: this.userLastNameBank,
                userTypeBank: this.userTypeBank,
                userBankName: this.userBankName,
                userCurrencyBank: this.userCurrencyBank,
                userCBU: this.userCbuBank,
                userAliasBank: this.userAliasBank,
                userCountry: this.userCountryBank, 
            }
            await axios.post('/index.php', payload).then(result => {
                this.loading = false;
                this.disabled = false;  
                try{
                    document.querySelector("[attr-id='manualPrice']").classList.remove("bad");   
                }catch(e){

                }
                if(result.data.status == '200'){    
                    this.errorText = 'Importe Confirmado';
                    this.toastBg = 'bg-success';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer3').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                        this.hideNotFound = true;
                        this.findBookings();
                        this.editPriceMode = false;
                    }catch(e){

                    }     
                }else if(result.data.status == '400'){
                    if(result.data.error == 'E20'){
                        this.errorText = 'Debes ingresar el nuevo importe.';
                        try{
                            document.querySelector("[attr-id='manualPrice']").classList.add("bad"); 
                            document.querySelector("[attr-id='manualPrice']").select();
                        }catch(e){

                        }
                    }else if(result.data.error == 'E21'){
                        this.errorText = 'El importe ingresado no es correcto.';
                        try{
                            document.querySelector("[attr-id='manualPrice']").classList.add("bad"); 
                            document.querySelector("[attr-id='manualPrice']").select();
                        }catch(e){

                        }
                    }else if(result.data.error == 'E22'){
                        this.errorText = 'El importe ingresado no es correcto.';
                        try{
                            document.querySelector("[attr-id='manualPrice']").classList.add("bad"); 
                            document.querySelector("[attr-id='manualPrice']").select();
                        }catch(e){

                        }
                    }else if(result.data.error == 'E210'){
                        this.errorText = 'Debes ingresar el nombre del titular de la cuenta';
                        document.querySelector("[attr-id='userFirstName']").classList.add("bad");  
                        document.querySelector("[attr-id='userFirstName']").select();
                    }else if(result.data.error == 'E211'){
                        this.errorText = 'El nombre del titular de la cuenta debe estar formado por un minimo de 2 caracteres y un maxímo de 100.';
                        document.querySelector("[attr-id='userFirstName']").classList.add("bad");  
                        document.querySelector("[attr-id='userFirstName']").select();
                    }else if(result.data.error == 'E212'){
                        this.errorText = 'El nombre del titular de la cuenta no puede contener numeros ni caracteres extraños.';
                        document.querySelector("[attr-id='userFirstName']").classList.add("bad");  
                        document.querySelector("[attr-id='userFirstName']").select();
                    }else if(result.data.error == 'E213'){
                        this.errorText = 'Debes ingresar el apellido del titular de la cuenta.';
                        document.querySelector("[attr-id='userLastName']").classList.add("bad");  
                        document.querySelector("[attr-id='userLastName']").select();
                    }else if(result.data.error == 'E214'){
                        this.errorText = 'El apellido del titular de la cuenta debe estar formado por un minimo de 2 caracteres y un maxímo de 100.';
                        document.querySelector("[attr-id='userLastName']").classList.add("bad");  
                        document.querySelector("[attr-id='userLastName']").select();
                    }else if(result.data.error == 'E215'){
                        this.errorText = 'El apellido del titular de la cuenta no puede contener numeros ni caracteres extraños.';
                        document.querySelector("[attr-id='userLastName']").classList.add("bad");  
                        document.querySelector("[attr-id='userLastName']").select();
                    }else if(result.data.error == 'E220'){
                        this.errorText = 'Debes seleccionar el país de la cuenta bancaria.';
                        document.querySelector("[attr-id='userCountryBank']").classList.add("bad");  
                    }else if(result.data.error == 'E221'){
                        this.errorText = 'Debes seleccionar el país de la cuenta bancaria.';
                        document.querySelector("[attr-id='userCountryBank']").classList.add("bad");  
                    }else if(result.data.error == 'E222'){
                        this.errorText = 'Debes seleccionar el país de la cuenta bancaria.';
                        document.querySelector("[attr-id='userCountryBank']").classList.add("bad");  
                    }else if(result.data.error == 'E230'){
                        this.errorText = 'Moneda invalida para el país de la cuenta bancaria.';
                        document.querySelector("[attr-id='userCurrencyBank']").classList.add("bad");  
                    }else if(result.data.error == 'E231'){
                        this.errorText = 'Moneda invalida para el país de la cuenta bancaria.';
                        document.querySelector("[attr-id='userCurrencyBank']").classList.add("bad");  
                    }else if(result.data.error == 'E240'){
                        this.errorText = 'Selecciona el Banco de tu cuenta.';
                        document.querySelector("[attr-id='userBankName']").classList.add("bad");  
                    }else if(result.data.error == 'E241'){
                        this.errorText = 'Selecciona el Banco de tu cuenta.';
                        document.querySelector("[attr-id='userBankName']").classList.add("bad");  
                    }else if(result.data.error == 'E255'){
                        this.errorText = 'Debes ingresar el ' + this.cbuText;
                        document.querySelector("[attr-id='userCbuBank']").classList.add("bad");  
                        document.querySelector("[attr-id='userCbuBank']").select();
                    }else if(result.data.error == 'E256'){
                        this.errorText = 'El ' + this.cbuText + ' no es correcto.';
                        document.querySelector("[attr-id='userCbuBank']").classList.add("bad");  
                        document.querySelector("[attr-id='userCbuBank']").select();
                    }else if(result.data.error == 'E257'){
                        this.errorText = 'El ' + this.cbuText + ' no es correcto.';
                        document.querySelector("[attr-id='userCbuBank']").classList.add("bad");  
                        document.querySelector("[attr-id='userCbuBank']").select();
                    }else if(result.data.error == 'E259'){
                        this.errorText = 'Debes elegir el tipo de cuenta.';
                        document.querySelector("[attr-id='userTypeBank']").classList.add("bad");     
                    }else if(result.data.error == 'E270'){
                        this.errorText = 'El ALIAS de la cuenta debe estar formado por un minimo de 2 caracteres y un maxímo de 200.';
                        document.querySelector("[attr-id='userAliasBank']").classList.add("bad");     
                    }				
                    this.toastBg = 'bg-danger';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer3').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){
                       
                    }
                    return;
                }


              
            })
            .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer3').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }   
                return;
            }) 
        },
        async confirmUserPrice(confirmPrice, ref){ 
            this.loading = true;
            this.disabled = true;   
            var payload = {
                action: 'confirm-price',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.userId,
                confirmPrice: confirmPrice,
                mode: this.userType,
                ref: ref
            }
            await axios.post('/index.php', payload)
            .then(result => {   
                this.loading = false;
                this.disabled = false;  
                if(result.data.status == '200'){
                    if(confirmPrice == true){
                        this.$router.push({ name: 'confirm-price'});     
                    }else{
                        this.$router.push({ name: 'decline-price'});
                    }    
                }else{
                    this.$router.push({ name: 'booking-not-found'});
                }         
            })
            .catch(error => {
                this.loading = false;
                this.disabled = false;
                this.errorText = 'Revise su conexión de internet.';
                var toast = new Toast(this.$refs.el)
                toast.show()	
                return;
            })
        },
        goToMeet(val){
            location.href = val
        },
        goToWhatsApp(val){
            location.href = "https://wa.me/"+ val
        },
        sendWa(id, room, groupId, clientName, linkVideoCall, roomIdLink, passVideoCall, now, date, hourStartClient, duration, service, clientPhone, modalityId, platformVideoCall, address){
            let url = "https://" + window.location.host + "/" + this.$route.params.browserCountry + "/" + this.$route.params.userLang + "/room/" + id;
            if(groupId != ''){
                url = url + '/' + groupId + '/external';
            }else{
                url = url + '/external';
            }
            var bookdate = '';
            if(now){
                bookdate = 'Hoy - (' + date + ')';
            }else{
                bookdate = date;
            }
            var name = clientName.split(" ")[0];
            var data = JSON.parse(localStorage.getItem('userData'));
            var sellerName = data.userFirstName + ' ' + data.userLastName;


            var message = '';
            if(modalityId != '1'){ //presencial
                message = `Hola ` + name + `, te recuerdo que tenemos una cita:
Día: *` + bookdate + `*
Hora: *` + hourStartClient + `* 
Duración: ` + duration + ` min
Te espero en: ` + address + ` 
Recuerda llegar puntual. 
Saludos Cordiales, ` + sellerName + `.`;
            }else{ //online
                if(platformVideoCall == 'Animasana'){
                    message = `Hola ` + name + `, te recuerdo que tenemos una cita:
Día: *` + bookdate + `*
Hora: *` + hourStartClient + `* 
Duración: ` + duration + ` min
Podrás acceder a la misma a través del siguiente link:  ` + url + ` 
Recuerda tener cargado tu dispositivo y estar en un lugar tranquilo con una buena conexión a internet.
Saludos Cordiales, ` + sellerName + `.`;
                }else{
                    if(roomIdLink == '' && passVideoCall == ''){
                        message = `Hola ` + name + `, te recuerdo que tenemos una cita:
Día: *` + bookdate + `*
Hora: *` + hourStartClient + `* 
Duración: ` + duration + ` min
Podrás acceder a la misma a través del siguiente link:  ` + linkVideoCall + ` 
Recuerda tener cargado tu dispositivo y estar en un lugar tranquilo con una buena conexión a internet.
Saludos Cordiales, ` + sellerName + `.`;

                    }else if(roomIdLink != '' && passVideoCall != ''){
                        message = `Hola ` + name + `, te recuerdo que tenemos una cita:
Día: *` + bookdate + `*
Hora: *` + hourStartClient + `* 
Duración: ` + duration + ` min
Podrás acceder a la misma a través del siguiente link:  ` + linkVideoCall + ` 
ID de la reunión: ` + roomIdLink + ` 
Clave: ` + passVideoCall + `
Recuerda tener cargado tu dispositivo y estar en un lugar tranquilo con una buena conexión a internet.
Saludos Cordiales, ` + sellerName + `.`;
                    }else if(roomIdLink != '' && passVideoCall == ''){
                        message = `Hola ` + name + `, te recuerdo que tenemos una cita:
Día: *` + bookdate + `*
Hora: *` + hourStartClient + `* 
Duración: ` + duration + ` min
Podrás acceder a la misma a través del siguiente link:  ` + linkVideoCall + ` 
ID de la reunión: ` + roomIdLink + `
Recuerda tener cargado tu dispositivo y estar en un lugar tranquilo con una buena conexión a internet.
Saludos Cordiales, ` + sellerName + `.`;
                    }else if(roomIdLink == '' && passVideoCall != ''){
                        message = `Hola ` + name + `, te recuerdo que tenemos una cita:
Día: *` + bookdate + `*
Hora: *` + hourStartClient + `* 
Duración: ` + duration + ` min
Podrás acceder a la misma a través del siguiente link:  ` + linkVideoCall + ` 
Clave: ` + passVideoCall + `
Recuerda tener cargado tu dispositivo y estar en un lugar tranquilo con una buena conexión a internet.
Saludos Cordiales, ` + sellerName + `.`;

                    }
                    
                }
            }
            location.href = "https://api.whatsapp.com/send?phone=" + clientPhone + "&text=" + encodeURI(message);
        }
    }
}
</script>

<style scoped>
.bookings-options > div{
    margin: 0;
}
.bookings-options:before{
    height: initial;
}
.absolute-pay{
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    height: 100%;
    background: #fff;
    z-index: 20000;
}
.bookings-options .badge.active{
    background: #198754;
    margin-right: 10px;
}
.bookings-options .badge.paused{
    background-color: #ffd900 !important;
    color: #605e5e;
}
.qr-container{
    width: 100%;
    height: 380px;
}
.bookings-options .close{
    top: 0;
}
@media (min-width: 680px) {
    .bookings-options .close {
        position: absolute;
        top: auto !important;
        right: calc((100% / 2) - 281px);
        width: 45px;
        height: 45px;
        font-size: 29px;
        z-index: 20000;
        color: #ffffff;
        cursor: pointer;
        display: flex;
        margin-top: -6px;
        border-radius: 50%;
        background: #004193;
        padding: 0;
        line-height: 46px;
    }
    .bookings-options .close:hover {
        background: #5acea4;
    }
}
.bookings-options .img-container img{
    max-width: 100%;
    margin-bottom: 0;
    border: 2px solid #00c7a2;
    border-radius: 50%;
    background: #fff;
}
@media (max-width: 576px){  
    .bookings-options .details{
        text-align: left;
    }
}
.bookings-options .cnt-list-group{
    border: 1px solid rgba(0,0,0,.125);
    padding: 10px;
    text-align: left;
    font-size: 14px;
    background: #fff;
}
.bookings-options .menu-options{
    background: #f2f3f8;
    color: #8b8b8b;
    border-radius: 20px 20px;
    border: 2px solid #5acea4;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.05), 0 0 6px 0 rgba(0, 0, 0, 0.05) !important;
}
@media (min-width: 680px) {
    .bookings-options .menu-options{
        min-width: 576px;
        max-width: 576px;
    }
}
.bookings-options .menu-options .details{
    background: #f2f3f8;
    border-radius: 10px 10px 0 0;
    color: #ffffff;
    box-shadow: none;
    border-bottom: 1px solid #004193;
    padding: 0;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    text-align: center;
    margin: 0px 10px;
    width: calc(100% - 20px);
    color: #004193;
}
.bookings-options .menu-options .details small{
    color: #3c4043;
}
.screen-waiting-calendar{
    position: fixed;
    z-index: 5000000;
    text-align: center;
    background: #004193;
    color: #fff;
    top: 0;
}
.bookings-options .bg-change-price{
    background: #e3e3e3;
    border-radius: 5px;
    padding: 10px !important;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.05), 0 0 6px 0 rgba(0, 0, 0, 0.05) !important;
    border: 1px solid #b5b5b5;
}
</style>